module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/badge/badge-with-notif/badge-with-notif.component.scss
// module id = ./src/app/features/badge/badge-with-notif/badge-with-notif.component.scss
// module chunks = main